export const ACCENT = "#1515FF";
export const BG_MAIN = "#F6F8FF";
export const CIRCLE_LOCKED_BG = "#EEF1FF";
export const CIRCLE_SHADOW = "0 4px 24px 0 #1515FF10";